<template>
  <div class="main-content">
    <section class="bg-white story">
      <div class="container">
        <div class="headline text-center">
          <div class="row">
            <div class="col-md-6 col-md-offset-3">
              <h2 class="section-title">Nossa história</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 col-md-offset-1 text-center">
            <p class="story-description">
              A <b>DIGIPROD</b> nasceu da paixão por tecnologia e inovação,
              unindo mais de 15 anos de experiência em desenvolvimento de
              software, automação de processos, infraestrutura e soluções
              escaláveis para a web.
            </p>
            <p class="story-description">
              Nosso fundador iniciou sua jornada como desenvolvedor full-stack,
              atuando em diversos projetos com foco em APIs REST, sistemas web,
              testes automatizados e infraestrutura em nuvem. Em seguida, com
              domínio em linguagens como JavaScript, Python, PHP, e experiência
              sólida em serviços como AWS, Docker, Jenkins e bancos de dados
              gerenciados, criamos soluções tecnológicas modernas e robustas.
            </p>
            <p class="story-description">
              Hoje, a <b>DIGIPROD</b> atua como uma plataforma de serviços sob
              demanda para pequenas e médias empresas, entregando soluções
              personalizadas de desenvolvimento, manutenção de sistemas,
              branding, infraestrutura e marketing digital.
            </p>
            <p class="story-description">
              Nossa missão é transformar ideias em soluções digitais acessíveis,
              com agilidade, qualidade e proximidade. Acreditamos que cada
              negócio pode crescer com a tecnologia, e estamos aqui para
              construir essa ponte.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "AboutMainContent",
};
</script>

<style scoped>
.story-description {
  text-align: justify;
  line-height: 1.8;
  margin-bottom: 2rem;
  font-family: "Helvetica Neue", Arial, sans-serif;
  color: #333;
}

.section-title {
  text-transform: uppercase;
  font-weight: 700;
  color: #2c3e50;
  letter-spacing: 2px;
}

.main-content {
  padding-top: 4rem;
  padding-bottom: 4rem;
}

/* Optional: Add a subtle animation for a more dynamic feel */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.story {
  animation: fadeIn 1.5s ease-in-out;
}
</style>
